import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { strings } from 'shared/translations'

type Language = 'en' | 'ru'

type LanguageStore = {
  language: Language
  changeLanguage: (value: Language) => void
}

export const useLanguage = create<LanguageStore>()(
  persist(
    (set) => ({
      language: 'en',
      changeLanguage: (value: Language) => {
        strings.setLanguage(value)
        document.title = strings.SETTINGS
        set({ language: value })
      },
    }),
    {
      name: 'language',
    },
  ),
)
